import SeoLandingTemplate, { SeoLandingPageData } from "@/components/marketing/SeoLandingTemplate";

const page: SeoLandingPageData = {
  path: "/tell-me-about-yourself",
  title: "Tell Me About Yourself Interview Answer",
  seoTitle: "How to Answer Tell Me About Yourself in an Interview | HiredCoach",
  seoDescription:
    "Learn how to answer 'Tell me about yourself' with a clear structure, a sample answer, and a fast path into Coach U practice.",
  heroEyebrow: '"Tell me about yourself"',
  heroHeadline: "Most people either ramble or fail to escape being forgettable",
  heroSubhead:
    "You think you know what to say Then you say it out loud and realize you're rambling, backtracking, or losing your point",
  heroPrimaryCta: "Practice, refine, and become unforgettable",
  heroPanelEyebrow: "What you should do",
  heroPanelTitle: "Keep it tight and focused",
  heroPanelBullets: [
    "Where you came from",
    "What built your inherit edge",
    "Why you're their future teammate",
  ],
  heroPanelFooter: "Be interesting, targeted, and desired",
  frameworkTitle: "What does a good answer sound like?",
  frameworkBullets: [
    "Starts with who you are right now",
    "Relates your history to key requirements for this role",
    "Makes the move to this job feel obvious and natural",
    "Stays under 60 to 90 seconds",
  ],
  exampleTitle: "Definitely don't",
  exampleBlocks: [
    "Ramble, jumping around in your timeline",
    "Talk about projects in no way relatable to the role",
    "Get too specific into details",
  ],
  pressureTitle: 'Some hate htis because it\'s "bragging"',
  pressureQuote: 'Others think it\'s about being "humble"',
  pressureBody: "But you need to be your biggest advocate",
  pressureFooter: "You have to make them see your journey through this role",
  mistakesTitle: "Where this usually goes sideways",
  mistakes: [
    "You start in college and dryly outline your entire career",
    "You add personal detail that doesn't help",
    "You walk through your resume instead of making a point",
    "You never connect what you've accomplished it to this role",
  ],
  mistakesFooter: "This is why they'll tune you out",
  ctaEyebrow: "Don't guess if your answer works",
  ctaTitle: "Try your first answer",
  ctaBullets: [
    "Say it out loud",
    "Hear what breaks",
    "Learn what you should have mentioned",
    "Try again",
  ],
  ctaInfoCard: {
    title: "Share your story - master your pitch",
    path: "/register",
    description: "HiredCoach is ready to help you master and target your pitch before the crucial interview",
  },
  ctaActionTitle: "Try your first answer",
  ctaActionDescription: "Say it out loud, hear what breaks, fix it, and try again.",
  relatedTitle: "If you're prepping like this, fix that too",
  relatedSubtext: "Most people only prep answers once. That's not enough.",
  relatedLinks: [
    {
      title: "Why Should We Hire You Answer",
      path: "/why-should-we-hire-you",
      description: "Answer 'Why should we hire you?' with a focused value pitch, a sample answer, and a direct path into practice and feedback.",
    },
    {
      title: "Common Interview Questions",
      path: "/common-interview-questions",
      description: "Use this hub page to prepare for the most common interview questions and jump into deeper answer guides and mock interview practice.",
    },
    {
      title: "How to Prepare for an Interview",
      path: "/how-to-prepare-for-an-interview",
      description: "A practical interview preparation guide covering research, answer practice, story prep, and mock interview rehearsal.",
    },
  ],
  faqs: [
    {
      question: "How long should a tell me about yourself answer be?",
      answer: "Usually 60 to 90 seconds. Long enough to sound real. Short enough to keep your point.",
    },
    {
      question: "Should you mention personal details?",
      answer: "Only if they help the interviewer understand your fit. Otherwise it is just extra noise.",
    },
  ],
};

const TellMeAboutYourselfPage = () => <SeoLandingTemplate page={page} />;

export default TellMeAboutYourselfPage;
